import { WhatsAppWhite } from 'constants/Images';
import { SHARE_ON_WHATSAPP } from 'constants/UserClicksConstant';
import { toJS } from 'mobx';
import AuthStore from 'modules/login/store/AuthStore';
import QmsDetailsPageStore from 'modules/qms-flow/qms-details-page/QmsDetailsPageStore';
import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import "./share-pdf.css"

const SharePdf = (props) => {
    const [data, setData] = useState('')

    let dummyData = [
        {
            member_name: "rushikesh goregaonkar",
            whatsapp_message: "Dear D D\n Welcome to Edelweiss Life Insurance Co. Ltd.!!\n Congratulations on taking the first step towards securing the future of your loved ones\nWe are sending you a carefully curated proposal to meet your financial requirements\n Do refer the same on the link below and we are happy to discuss further!\n Solution Presentation : edlws.in/r25n7cjh\n  Bonus History_Flexi Savings Income : https://nauat.edelweisslife.in/media/pdf/Bonus%20History_Flexi%20Savings%20Income.pdf"
        },
        {
            member_name: "adsds sdfsdf",
            whatsapp_message: "Dear D D\n Welcome to Edelweiss Life Insurance Co. Ltd.!!\n Congratulations on taking the first step towards securing the future of your loved ones\nWe are sending you a carefully curated proposal to meet your financial requirements\n Do refer the same on the link below and we are happy to discuss further!\n Solution Presentation : edlws.in/r25n7cjh\n  Bonus History_Flexi Savings Income : https://nauat.edelweisslife.in/media/pdf/Bonus%20History_Flexi%20Savings%20Income.pdf"
        }
    ]

    useEffect(() => {
        const orignalData = QmsDetailsPageStore.sharePdfData
        setData(orignalData)
    }, [])
    const generateWhatsAppLink = (url,mobileNumber) => {
        return `https://api.whatsapp.com/send?phone=${mobileNumber}&text=${encodeURIComponent(url)}`;
    };

    const clickButton = (index) => {
        //!for save user clicks
        AuthStore.saveUserClicks(SHARE_ON_WHATSAPP)
        // let updatedData = data.map((item, idx) => {
        //     if (idx === index) {
        //         return { ...item, isSelected: !item.isSelected };
        //     }
        //     return item;
        // });
        // const allSelected = updatedData.every(item => item.isSelected);
        // AuthStore.setshowSharePdfModal(!allSelected)
        // setData(updatedData)

    }


    return (
        <Modal
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className="save-session-modal"
            // className="share-pdf-modal "
            show={props.show}
            keyboard={false}
        >
            <Modal.Body className="">
                <React.Fragment>
                    <div>
                        <p className="text-center align-items-center font-size-20">
                            Share PDF Document via WhatsApp
                        </p>
                        <div className='mt-5'>
                            {data &&
                                data?.map((item, index) => {
                                    return (
                                        <div className='py-1 whatsapp-card mb-3 d-flex justify-content-between px-3 bg-light-gray'>
                                            <div>
                                                <p className="font-weight-bold mb-0 pr-3 py-2 font-size-16">
                                                    {index + 1}. {item?.member_name}
                                                </p>

                                            </div>
                                            <div>
                                                <Button

                                                    href={generateWhatsAppLink(item?.whatsapp_message,item?.mobile_number)}
                                                    target="_blank"
                                                    className={'pl-2 text-white font-size-14 py-2 share-pdf-button bg-success btn-success'}
                                                    onClick={() => clickButton(index)}
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={WhatsAppWhite} width={20} height={20} />
                                                    <span className='pl-1'>Send</span>
                                                </Button>
                                            </div>

                                        </div>
                                    )
                                })}
                        </div>
                    </div>
                </React.Fragment>
            </Modal.Body>
            <Modal.Footer className="d-block border-0">
                <div className="w-100 text-center">
                    <button
                        className=" w-25 btn btn-link btn-lg modal-cta-btn modal-cta-btn-link py-2 py-lg-1 font-size-14 font-weight-medium"
                        onClick={() => QmsDetailsPageStore.setshowSharePdfmodal(false)}
                    >
                        Close
                    </button>
                </div>
            </Modal.Footer>
        </Modal >
    );
};

export default SharePdf;
